import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_instructor/on-demand-tutoring')({
  component: () => <Outlet />,
});
